module.exports = __webpack_public_path__ + "media/images/brand/app_logo_400-791b81f5f3a1c59b32c1e4c8f1151bec.png";